import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/* 
  TODO set raw bytes:

  https://stackoverflow.com/questions/45596329/display-pdf-in-reactjs

  if your data that is returned from the backend is in the format of buffer then you can set the file info with a parsed JSON object that react-pdf can configure.
  file={{data: JSON.parse(renderPDF).data}}

*/

type PdfProps = {
  content?: any;
  zoom?: number;
  rotation?: number;
};

export function useContainerDimensions(ref: React.RefObject<any>) {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getDimensions = () => ({
      width: (ref && ref.current.offsetWidth) || 0,
      height: (ref && ref.current.offsetHeight) || 0,
    });

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (ref.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);

  return dimensions;
}

const pageIndexStyle = { color: '#777', height: 24 };
const PageIndex = ({ page }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(page);

  useEffect(() => {
    setTimeout(() => {
      setCount(countRef.current);
    }, 10);
  }, []);

  return <span style={pageIndexStyle}>{count ? 'Page ' + count : ''}</span>;
};

export function Pdf(props: PdfProps) {
  const { content, zoom, rotation } = props;

  const [numPages, setNumPages] = useState(1);
  //TODO: per page navitation
  // const [pageNumber, setPageNumber] = useState(1);

  const ref = useRef(null);
  const { width, height } = useContainerDimensions(ref);
  useEffect(() => {
    // console.log('div width', ref.current ? ref.current.offsetWidth : 0);
  }, [ref.current]);

  function onDocumentLoadSuccess({ numPages }) {
    // console.log('setNumPages', numPages);
    setNumPages(numPages);
  }

  //TODO: device query to set resolution and size  width={window.screen.width * .4} height={window.screen.height * .8}
  // console.log('res', window.screen.width, window.screen.height)

  const scale = zoom || 1;
  const rotate = rotation || 0;

  return (
    content && (
      <div
        id="pdf"
        ref={ref}
        style={{
          padding: 12,
          paddingRight: 24,
          width: '65vw',
          height: '83vh',
          overflowY: 'auto',
          overflowX: 'auto',
        }}
      >
        <Document file={content} onLoadSuccess={onDocumentLoadSuccess}>
          {[...Array(numPages)].map((_, i) => (
            <>
              <PageIndex page={i + 1} />
              <Page
                loading=" "
                pageNumber={i + 1}
                width={width}
                height={height}
                scale={scale}
                rotate={rotate}
              />
              <br />
            </>
          ))}
        </Document>
      </div>
    )
  );
}
